// extracted by mini-css-extract-plugin
export var actions = "style-module--actions--333e8";
export var banner = "style-module--banner--5dc0d";
export var button = "style-module--button--0e10a";
export var buttonSecondary = "style-module--buttonSecondary--a0983";
export var inner = "style-module--inner--39994";
export var link = "style-module--link--8b125";
export var text = "style-module--text--9c5b0";